import React, { useEffect, useState } from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { adminAPI } from '../../services/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { toast } from 'sonner';
import { formatDate } from '../../utils/helpers';

export const AdminOrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAPI.getOrders(0, 200)
      .then(res => setOrders(res.data))
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout>
      <div className="space-y-6" data-testid="admin-orders-page">
        <div>
          <h1 className="text-4xl font-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>Orders</h1>
          <p className="mt-2 text-muted-foreground">All customer orders</p>
        </div>
        <Card>
          <CardHeader><CardTitle>All Orders ({orders.length})</CardTitle></CardHeader>
          <CardContent>
            {loading ? <p className="text-center py-8">Loading...</p> : orders.length === 0 ? (
              <p className="text-center py-8 text-muted-foreground">No orders yet</p>
            ) : (
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Date</TableHead>
                    <TableHead>User</TableHead>
                    <TableHead>Items</TableHead>
                    <TableHead>Total</TableHead>
                    <TableHead>Status</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {orders.map(o => (
                    <TableRow key={o.id}>
                      <TableCell className="text-xs">{formatDate(o.created_at)}</TableCell>
                      <TableCell className="font-mono text-xs">{o.user_id?.substring(0, 12)}</TableCell>
                      <TableCell>{o.items?.length || 0} items</TableCell>
                      <TableCell className="font-semibold">{o.total} {o.currency}</TableCell>
                      <TableCell><Badge className="bg-green-600">{o.status}</Badge></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};
